import React from 'react';
import { Phone, Mail, ArrowUp, MapPin, Clock } from 'lucide-react';

const Footer = () => {
  const goTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <>
      <footer className="pool-footer">
        <div className="pool-footer-content">
          <div className="pool-footer-grid">
            <div className="pool-footer-section">
              <h4>Contact Information</h4>
              <p className="mb-2 d-flex align-items-center gap-2">
                <Phone size={18} />
                <span>03522-255450</span>
              </p>
              <p className="mb-2 d-flex align-items-center gap-2">
                <Mail size={18} />
                <span>bmpality@gmail.com</span>
              </p>
              <p className="mb-0 d-flex align-items-center gap-2">
                <MapPin size={18} />
                <span>Balurghat, Dakshin Dinajpur, West Bengal</span>
              </p>
            </div>
            
            <div className="pool-footer-section">
              <h4>Working Hours</h4>
              <p className="mb-2 d-flex align-items-center gap-2">
                <Clock size={18} />
                <span>Monday - Saturday: 6:00 AM - 8:00 PM</span>
              </p>
              <p className="mb-0 d-flex align-items-center gap-2">
                <Clock size={18} />
                <span>Sunday: 6:00 AM - 12:00 PM</span>
              </p>
            </div>
            
            <div className="pool-footer-section">
              <h4>Quick Links</h4>
              <p className="mb-2">
                <a href="/about">About Us</a>
              </p>
              <p className="mb-2">
                <a href="/guidelines">Guidelines</a>
              </p>
              <p className="mb-0">
                <a href="/contact">Contact</a>
              </p>
            </div>
            
            <div className="pool-footer-section">
              <h4>Help & Support</h4>
              <p className="mb-2">
                For any technical assistance or queries regarding swimming pool registration, please contact our support team.
              </p>
              <p className="mb-0">
                <a href="/support">Get Support</a>
              </p>
            </div>
          </div>
          
          <div className="pool-footer-bottom">
            <p className="mb-2">
              Designed & Developed by Balurghat Municipality IT Cell
            </p>
            <p className="mb-0">
              © {new Date().getFullYear()} বালুরঘাট পৌরসভা সুইমিং পুল | All Rights Reserved
            </p>
          </div>
        </div>
        
        <button
          type="button"
          className="pool-to-top"
          onClick={goTop}
          aria-label="Back to top"
        >
          <ArrowUp size={20} />
        </button>
      </footer>
    </>
  );
};

export default Footer;
